import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";
import config from "config/config";

export const background = {
  bg: "greyscale.200",
  bgImage: {
    base: "none",
    lg: `url(${config.staticUrl}/i/about-us/background-hills.svg)`,
  },
  bgRepeat: "no-repeat",
  bgPosition: "right bottom",
};

export const textStyles: RichtextAdapterProps["customStyles"] = {
  paragraph: {
    fontSize: "lg",
    maxW: { base: "100vw", lg: "55vw", xl: "46vw" },
    textAlign: { base: "left", md: "center" },
    px: { base: 4, lg: 0 },
    lineHeight: "tall",
    mb: 4,
    _last: { mb: { base: 6, lg: 16 } },
  },
};
